import {
    geoMercator,
    geoPath,
}                          from "d3-geo"
import isEqual             from "lodash.isequal"
import React               from "react"
import { connect }         from "react-redux"
import { withRouter }      from "react-router-dom"
import styled              from "styled-components"
import { setSelectedWard } from "../../../infraMonitor/projects-stats/actions"
import {
    getMun,
    getMunData,
}                          from "../../../utils"

const municipality = getMun()
const subDomainData = getMunData()

// const colorScale = val =>
//   scaleQuantize()
//     .domain([0, val])
//     .range(["#1b2738", "#253a59", "#204884", "#1b60c8"]);

let geojson

if (municipality === "") {
    import(`../geojson/dhangadhi-geojson.json`).then(res => (geojson = res))
} else if (subDomainData.title) {
    import(`../geojson/${municipality}-geojson.json`).then(
        res => (geojson = res),
                                                     )
                                                     .catch(err => null)
}

class Map extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            parentWidth: 0,
        }
        this.ref = React.createRef()
    }

    componentDidMount() {
        this.fitParentContainer()
        window.addEventListener("resize", this.fitParentContainer)
    }

    fitParentContainer = () => {
        const { parentWidth } = this.state

        const currentParentWidth =
            this.ref.current && this.ref.current.getBoundingClientRect().width

        const shouldResize = parentWidth !== currentParentWidth
        if (shouldResize) {
            this.setState({
                parentWidth: currentParentWidth,
            })
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { data, width, selectedLanguage } = nextProps
        const { parentWidth } = nextState

        return (
            !isEqual(data, this.props.data) ||
            width !== this.props.width ||
            parentWidth !== this.props.parentWidth ||
            selectedLanguage !== this.props.selectedLanguage
        )
    }

    // getColor = (d, color) => {
    //   const { Name } = d.properties;
    //   const { data } = this.props;
    //   const value = data
    //     .filter(obj => `Ward ${obj.ward}` === Name)
    //     .map(obj => obj.value);

    //   const colorValue = color(value[0]);
    //   if (colorValue) {
    //     return colorValue.toString();
    //   }
    //   return "#121f2e";
    // };
    // getValue = d => {
    //   const { Name } = d.properties;
    //   const { data } = this.props;
    //   const value = data
    //     .filter(obj => `Ward ${obj.ward}` === Name)
    //     .map(obj => obj.value);

    //   return value[0];
    // };
    // clickToView = d => {
    //   const { selectedLanguage } = this.props;
    //   if (selectedLanguage === "np") {
    //     return `<span><strong>वडा ${number(
    //       d.properties.Name.replace("Ward ", "")
    //     )}</strong> हेर्नका लागि थिच्नुस ।</span>`;
    //   }
    //   return `<span>Click to view <strong>Ward ${number(
    //     d.properties.Name.replace("Ward ", "")
    //   )}</strong></span>`;
    // };

    // getTotalWards = () => {
    //   const { municipality, municipalities } = this.props;
    //   const currentMunicipality = municipalities.find(
    //     val => val.name === municipality.title_en
    //   );
    //   return currentMunicipality.no_of_wards;
    // };

    render() {
        const { parentWidth } = this.state

        const height = parentWidth
        const projection = geoMercator()
            .fitExtent(
                [[0, 0], [parentWidth * 0.9, height * 0.9]],
                geojson,
            )
        const path = geoPath()
            .projection(projection)

        if (!geojson) {
            return null
        }

        return (
            <MapSection className="map" innerRef={this.ref}>
                <div>
                    <svg width={parentWidth} height={height}>
                        <g className="geojson-layer">
                            {geojson.features.map(d => (
                                <path
                                    key={1}
                                    d={path(d)}
                                    fill="#253a59"
                                    stroke="#0e1724"
                                    strokeWidth="1"
                                    strokeOpacity="0.5"
                                />
                            ))}
                        </g>
                    </svg>
                </div>
                <div className={'tooltip-map-social'} id="tooltip-map"/>
            </MapSection>
        )
    }
}

const MapSection = styled.div`
  /* width: 100%; */
`
const mapStateToProps = state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage,
    fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
    municipalities: state.staticData.municipalities,
})
const mapDispatchToProps = dispatch => ({
    dispatchSelectedWard: selectedWard => dispatch(setSelectedWard(selectedWard)),
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Map),
)



// WEBPACK FOOTER //
// ./src/components/visualization/map/basicMap.js